<div style="float:left;clear:none;width:45%;padding:0px;margin:auto;margin-top:0px">

  <mat-accordion multi="true" displayMode="default">
    <mat-expansion-panel [expanded]="true" (opened)="isOpen[0] = true" (closed)="isOpen[0] = false">
      <mat-expansion-panel-header class="personalitzat-header3">
        <mat-panel-title>{{ 'dashboardPanells.miPresentadesRequeriments' | translate }}</mat-panel-title>
        <mat-icon class="custom-icon" style="margin-left: auto">
          {{ isOpen[0] ? 'remove' : 'add' }}
        </mat-icon>
      </mat-expansion-panel-header>
      <mcrit-gestio-last-incidencia-0></mcrit-gestio-last-incidencia-0>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" (opened)="isOpen[2] = true" (closed)="isOpen[2] = false">
      <mat-expansion-panel-header class="personalitzat-header3">
        <mat-panel-title>{{ 'dashboardPanells.propostesPresentadesRequeriments' | translate }}</mat-panel-title>
        <mat-icon class="custom-icon" style="margin-left: auto">
          {{ isOpen[2] ? 'remove' : 'add' }}
        </mat-icon>
      </mat-expansion-panel-header>
      <mcrit-gestio-last-incidencia-2></mcrit-gestio-last-incidencia-2>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" (opened)="isOpen[4] = true" (closed)="isOpen[4] = false">
      <mat-expansion-panel-header class="personalitzat-header4">
        <mat-panel-title>{{ 'dashboardPanells.propostesAprovadesContractacio' | translate }}</mat-panel-title>
        <mat-icon class="custom-icon" style="margin-left: auto">
          {{ isOpen[4] ? 'remove' : 'add' }}
        </mat-icon>
      </mat-expansion-panel-header>
      <mcrit-gestio-last-incidencia-4></mcrit-gestio-last-incidencia-4>
    </mat-expansion-panel>

  </mat-accordion>
</div>
<div style="float:left;clear:none;width:45%;padding:0px;margin:auto;margin-top:0px">
  <mat-accordion multi="true" displayMode="default">

  <!-- Propostes 'Presentades' -->
  <mat-expansion-panel [expanded]="true" (opened)="isOpen[1] = true" (closed)="isOpen[1] = false">
    <mat-expansion-panel-header class="personalitzat-header3">
      <mat-panel-title>{{ 'dashboardPanells.propostesPresentades' | translate }}</mat-panel-title>
      <mat-icon class="custom-icon" style="margin-left: auto">
        {{ isOpen[1] ? 'remove' : 'add' }}
      </mat-icon>
    </mat-expansion-panel-header>
    <mcrit-gestio-last-incidencia-1></mcrit-gestio-last-incidencia-1>
  </mat-expansion-panel>


    <mat-expansion-panel [expanded]="true" (opened)="isOpen[3] = true" (closed)="isOpen[3] = false">
      <mat-expansion-panel-header class="personalitzat-header">
        <mat-panel-title>{{ 'dashboardPanells.treballsIniciatsPendentsContracte' | translate }}</mat-panel-title>
        <mat-icon class="custom-icon" style="margin-left: auto">
          {{ isOpen[3] ? 'remove' : 'add' }}
        </mat-icon>
      </mat-expansion-panel-header>
      <mcrit-gestio-last-incidencia-3></mcrit-gestio-last-incidencia-3>
    </mat-expansion-panel>

</mat-accordion>
</div>
